import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export function createStore () {
  return new Vuex.Store({
    state: {
      version: '2.1.0',
      product: 'Stratitude Share',
      platform: 'web'
    }
  })
}
